import {
  apiRequest,
  PetaJabatanUpdateKP,
  PetaJabatanDetailKP,
  PetaJabatanlistEmployee,
} from "../../../../../services/adapters/kepegawaian/PetaJabatanService";

class CreateRepository {
  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      PetaJabatanUpdateKP,
      {
        body: query,
      },
      true
    );
  };

  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      PetaJabatanDetailKP,
      {
        params: query,
      },
      true
    );
  };

  fetchEmployee = async (query) => {
    return await apiRequest(
      "get",
      PetaJabatanlistEmployee,
      {
        params: query,
      },
      true
    );
  };
}

export default CreateRepository;
